// One workspace card on the bare-`/w` hub page (pages/workspaceHub.js).
// Bare shared-library import, not a deep workspacePrefix.js subpath — see
// app.js's identical fix note (tickets/catalog-fixall.md P0).
import _wsShared from '@symbo-ls/workspace-shared'
const shellWithWorkspacePrefix = (...args) => _wsShared.functions.withWorkspacePrefix(...args)

export const WorkspaceHubCard = {
  extends: 'CommonCard',
  tag: 'button',
  type: 'button',
  flow: 'x',
  align: 'center left',
  gap: 'A',
  padding: 'A1',
  round: 'radiusCard',
  borderWidth: '0',
  cursor: 'pointer',
  textAlign: 'left',
  color: 'title',
  transition: '120ms ease background, 120ms ease transform',
  ':hover': {
    background: 'hover',
    transform: 'translateY(-2px)'
  },
  onClick: (e, el, s) => {
    const slug = s.slug || s.username
    if (!slug) return
    el.router(shellWithWorkspacePrefix(slug, '/'), el.getRoot())
  },

  Avatar: {
    avatarType: 'initials',
    boxSize: 'C',
    round: 'radiusCard',
    flexShrink: '0',
    src: (el, s) => el.call('avatarUrl', s.name || s.slug || '')
  },

  Info: {
    flow: 'y',
    gap: 'V',
    flex: '1',
    minWidth: '0',

    Name: {
      tag: 'span',
      fontSize: 'A',
      fontWeight: '700',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      text: (el, s) => s.name || s.slug || ''
    },
    Role: {
      tag: 'span',
      fontSize: 'Y2',
      color: 'caption',
      text: (el, s) => s.role || s.membership?.role || 'member'
    }
  },

  Icon: { name: 'chevronRight', color: 'caption', flexShrink: '0' }
}
